import { create } from 'zustand';

/**
 * A widget's contribution to the full-dashboard zip export. Chart widgets
 * produce a rendered `image` (canvas → PNG); table widgets (regular and custom
 * datasource) produce `csv` text written as a `.csv` entry. `useGetZip`
 * branches on `kind` when assembling the zip.
 */
export type WidgetExportContent =
  | { kind: 'image'; canvas: HTMLCanvasElement }
  | { kind: 'csv'; csv: string };

interface WidgetExport {
  id: string;
  /** Base filename (no extension) for the widget's entry in the zip export. */
  filename: string;
  exportFn: () => Promise<WidgetExportContent | undefined>;
}

interface BulkExportState {
  widgetExports: WidgetExport[];
  addWidgetExport: (widgetExport: WidgetExport) => void;
  removeWidgetExport: (id: string) => void;
  clearWidgetExports: () => void;
}

export const useDashboardBulkExportStore = create<BulkExportState>((set) => ({
  widgetExports: [],
  addWidgetExport: (widgetExport) => {
    set((state) => ({
      widgetExports: [
        ...state.widgetExports.filter((item) => item.id !== widgetExport.id),
        widgetExport,
      ],
    }));
  },
  removeWidgetExport: (id) => {
    set((state) => ({
      widgetExports: state.widgetExports.filter(
        (exportItem) => exportItem.id !== id
      ),
    }));
  },
  clearWidgetExports: () => set({ widgetExports: [] }),
}));
